module.exports = __webpack_public_path__ + "static/fb-icon-3be4d89e248656dba32e77870f6f2183.png";